import React, { useEffect, useState } from "react";
import "./MobileList.css";
import jsPDF from "jspdf";

const MobileList = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    setLoading(true);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/get_mobile_list.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: user.id })
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        setList(data.data);
      } else {
        alert(data.message || "No records found");
      }
    } catch (e) {
      alert("Server error");
    }

    setLoading(false);
  };

  /* ===== PDF DOWNLOAD ===== */
  const downloadPDF = (row) => {
    const doc = new jsPDF("p", "mm", "a4");
    let y = 14;

    doc.setFontSize(14);
    doc.text("Mobile Search Report", 10, y);
    y += 10;

    doc.setFontSize(10);

    const data = JSON.parse(row.response_json);

    const writeObject = (obj, indent = 0) => {
      for (const key in obj) {
        if (y > 280) {
          doc.addPage();
          y = 14;
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          doc.text(`${" ".repeat(indent)}${key}:`, 10, y);
          y += 6;
          writeObject(obj[key], indent + 4);
        } else {
          const text = `${" ".repeat(indent)}${key}: ${String(obj[key])}`;
          const wrapped = doc.splitTextToSize(text, 180);
          doc.text(wrapped, 10, y);
          y += wrapped.length * 6;
        }
      }
    };

    writeObject(data);
    doc.save(`mobile_${row.mobile}.pdf`);
  };

  return (
    <div className="mobilelist-page">

      <h2 className="mobilelist-title">📱 Mobile Number List</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="mobilelist-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Mobile</th>
              <th>Price</th>
              <th>Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {list.length === 0 && (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            )}

            {list.map((row, i) => (
              <tr key={row.id}>
                <td>{i + 1}</td>
                <td>{row.mobile}</td>
                <td>₹{row.price}</td>
                <td>
                  <span className={`status ${row.status}`}>
                    {row.status}
                  </span>
                </td>
                <td>{row.created_at}</td>
                <td>
                  <button
                    className="view-btn"
                    onClick={() => setSelected(row)}
                  >
                    View
                  </button>

                  <button
                    className="pdf-btn"
                    onClick={() => downloadPDF(row)}
                  >
                    PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ===== MODAL ===== */}
      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Mobile Search Details</h3>
            <pre>
              {JSON.stringify(
                JSON.parse(selected.response_json),
                null,
                2
              )}
            </pre>
            <button onClick={() => setSelected(null)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default MobileList;
